<main class="products-page">
  <header class="site-header" aria-label="S.R.Organic product navigation">
    <a class="brand" routerLink="/" fragment="home" aria-label="S.R. Organic home">
      <span class="brand-mark" aria-hidden="true">🍄</span>
      <strong>S.R.ORGANIC</strong>
    </a>

    <nav class="main-nav" aria-label="Primary navigation">
      <a routerLink="/" fragment="home">Home</a>
      <a routerLink="/" fragment="about">About Us</a>
      <a routerLink="/products" class="active">Products</a>
      <a routerLink="/" fragment="why-us">Why Us</a>
      <a routerLink="/" fragment="contact">Contact Us</a>
    </nav>
  </header>

  <section class="products-hero">
    <p class="eyebrow">{{ pageContent.eyebrow }}</p>
    <h1>{{ pageContent.headline }}</h1>
    <p>
      {{ pageContent.description }}
    </p>
  </section>

  <section class="products-content" aria-label="S.R.Organic product list">
    <div class="empty-products" *ngIf="isLoading">
      <h2>Loading products...</h2>
      <p>Fetching the latest S.R.ORGANIC catalog.</p>
    </div>

    <div class="empty-products" *ngIf="!isLoading && errorMessage">
      <h2>Products unavailable.</h2>
      <p>{{ errorMessage }}</p>
    </div>

    <div class="products-toolbar" aria-label="Product filters">
      <label class="search-field">
        <span>Search</span>
        <input type="search" [(ngModel)]="searchTerm" placeholder="Search products" />
      </label>

      <label class="category-field">
        <span>Category</span>
        <select [(ngModel)]="selectedCategory">
          <option value="">All categories</option>
          <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
        </select>
      </label>

      <strong class="active-count">{{ filteredProductGroups.length }} active products</strong>
    </div>

    <div class="products-grid" *ngIf="!isLoading">
      <article *ngFor="let group of filteredProductGroups; trackBy: trackByProduct" class="product-card">
        <img class="product-card-image" [src]="group.product.imageUrl" [alt]="group.product.name" />
        <div class="product-card-body">
          <span class="product-card-category">{{ group.product.category }}</span>
          <h2 class="product-card-title">{{ group.product.name }}</h2>
          <p class="product-card-description">{{ group.product.longDescription || group.product.shortDescription }}</p>

          <div class="child-products" *ngIf="group.children.length">
            <h3 class="child-products-title">Child products</h3>
            <ul class="child-product-list">
              <li
                *ngFor="let child of group.children; trackBy: trackByChild"
                class="child-product-chip"
                [title]="child.shortDescription"
              >
                {{ child.name }}
              </li>
            </ul>
          </div>

          <a class="product-card-link" [routerLink]="['/products', group.product.id]">
            Explore details <span aria-hidden="true">→</span>
          </a>
        </div>
      </article>

      <div class="empty-products" *ngIf="!filteredProductGroups.length">
        <h2>No products found.</h2>
        <p>Try a different search term or category.</p>
      </div>
    </div>
  </section>
</main>
